module.exports = __webpack_public_path__ + "img/bilibili-winter-tree-2.5f90f1cb.5f90f1cb.png";